// extracted by mini-css-extract-plugin
module.exports = {"singleLineTitle":"makeShopProductCard_singleLineTitle__vxCOG","bottomTablet":"makeShopProductCard_bottomTablet__1EwRd"};